import { axios } from '@/utils/request'

const api = {
    sellerRewardSetting: '/badminapi/business/sellerRewardSetting',
    allRewardSetting: '/badminapi/business/allRewardSetting',
    partnerCashSetting: '/badminapi/business/partnerCashSetting',
    memberDiscountSetting: '/badminapi/business/memberDiscountSetting',
    getSellerRewardSetting: '/badminapi/business/getSellerRewardSetting',
    getAllRewardSetting: '/badminapi/business/getAllRewardSetting',
    getPartnerCashSetting: '/badminapi/business/getPartnerCashSetting',
    getMemberDiscountSetting: '/badminapi/business/getMemberDiscountSetting',
    businessSetting: '/badminapi/business/businessSetting',
    businessSettingActivity: '/badminapi/business/businessSettingActivity',
    getBusinessSetting: '/badminapi/business/getBusinessSetting',
    getBusinessUserList: '/badminapi/business/businessUserList',
    addBusinessUser: '/badminapi/business/addBusinessUser',
    deleteBusinessUser: '/badminapi/business/deleteBusinessUser',
    getBusinessPurviewList: '/badminapi/business/businessPurviewList',
    getTreeData: '/badminapi/business/getTreeData',
    addPurview: '/badminapi/business/businessPurviewAdd',
    getUserPermission: '/badminapi/business/userPermission',
    deleteRole: '/badminapi/business/deleteRole',
    editPurview: '/badminapi/business/businessPurviewEdit',

}

export default api

export function businessPurviewEdit(parameter) {
    return axios({
        url: api.editPurview,
        method: 'post',
        data: parameter
    })
}
export function roleDelete(parameter) {
    return axios({
        url: api.deleteRole,
        method: 'post',
        data: parameter
    })
}

export function getUserPermission(parameter) {
    return axios({
        url: api.getUserPermission,
        method: 'post',
        data: parameter
    })
}

export function businessPurviewAdd(parameter) {
    return axios({
        url: api.addPurview,
        method: 'post',
        data: parameter
    })
}

export function getPurviewList(parameter) {
    return axios({
        url: api.getBusinessPurviewList,
        method: 'get',
        data: parameter
    })
}

export function getTreeData(parameter) {
    return axios({
        url: api.getTreeData,
        method: 'get',
        data: parameter
    })
}

export function sellerRewardSetting(parameter) {
    return axios({
        url: api.sellerRewardSetting,
        method: 'post',
        data: parameter
    })
}

export function allRewardSetting(parameter) {
    return axios({
        url: api.allRewardSetting,
        method: 'post',
        data: parameter
    })
}

export function partnerCashSetting(parameter) {
    return axios({
        url: api.partnerCashSetting,
        method: 'post',
        data: parameter
    })
}
export function getAllRewardSetting(parameter) {
    return axios({
        url: api.getAllRewardSetting,
        method: 'post',
        data: parameter
    })
}
export function getSellerRewardSetting(parameter) {
    return axios({
        url: api.getSellerRewardSetting,
        method: 'post',
        data: parameter
    })
}
export function getPartnerCashSetting(parameter) {
    return axios({
        url: api.getPartnerCashSetting,
        method: 'post',
        data: parameter
    })
}

export function memberDiscountSetting(parameter) {
    return axios({
        url: api.memberDiscountSetting,
        method: 'post',
        data: parameter
    })
}
export function getMemberDiscountSetting(parameter) {
    return axios({
        url: api.getMemberDiscountSetting,
        method: 'post',
        data: parameter
    })
}
export function businessSetting(parameter) {
    return axios({
        url: api.businessSetting,
        method: 'post',
        data: parameter
    })
}
export function businessSettingActivity(parameter) {
    return axios({
        url: api.businessSettingActivity,
        method: 'post',
        data: parameter
    })
}
export function getBusinessSetting(parameter) {
    return axios({
        url: api.getBusinessSetting,
        method: 'post',
        data: parameter
    })
}
export function getBusinessUserList(parameter) {
    return axios({
        url: api.getBusinessUserList,
        method: 'post',
        data: parameter
    })
}
export function deleteBusinessUser(parameter) {
    return axios({
        url: api.deleteBusinessUser,
        method: 'post',
        data: parameter
    })
}
export function addBusinessUser(parameter) {
    return axios({
        url: api.addBusinessUser,
        method: 'post',
        data: parameter
    })
}